
import { actionsStore } from "@/components/Table/actionsStore";
import { cadastroEmpresaCopiaMixin } from "@/modules/GrupoEmpresa/mixins/cadastroEmpresaCopia";

export default {
  name: "CadastroEmpresaCopiarButton",
  mixins: [cadastroEmpresaCopiaMixin],
  props: {
    modulo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      actionsStore,
      empresasSelecionadas: [],
      copiando: false,
    };
  },
  computed: {
    quantidadeSelecionada() {
      return (this.actionsStore.selectedRows || []).length;
    },
  },
  methods: {
    abrirModal() {
      if (!this.quantidadeSelecionada) return;

      this.empresasSelecionadas = [];
      this.$refs.modal.show();
    },
    async copiar(event) {
      event.preventDefault();
      if (!this.empresasSelecionadas.length || this.copiando) return;

      this.copiando = true;

      try {
        const response = await this.$http.post(
          `/empresa/grupos/${this.empresaContexto.id_grupo_empresa}/cadastros/copiar`,
          {
            modulo: this.modulo,
            registros: this.actionsStore.selectedRows.map((row) =>
              Number(row.id || row.id_pessoa)
            ),
            empresas: this.empresasSelecionadas,
            empresa_origem: Number(this.empresaContexto.id_empresa),
          }
        );
        const resultado = response.data.data || {};
        const detalhes = [];

        if (resultado.existentes) {
          detalhes.push(`${resultado.existentes} já existentes`);
        }
        if (resultado.nao_encontrados) {
          detalhes.push(`${resultado.nao_encontrados} ignorados`);
        }
        if (resultado.dependencias_criadas) {
          detalhes.push(
            `${resultado.dependencias_criadas} vínculos auxiliares criados`
          );
        }

        this.$toast.success(
          `${resultado.criados || 0} cadastros copiados${
            detalhes.length ? `. ${detalhes.join(", ")}.` : "."
          }`
        );
        this.$refs.modal.hide();
        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = Date.now();
      } finally {
        this.copiando = false;
      }
    },
  },
};
